export default {"src":"/_next/static/media/arrow-right.c5d6cda8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};